import React, { useEffect, useMemo } from 'react'
import { injectIntl, intlShape } from 'react-intl'
import NvLogo from './logo.png'
import T from '../Components/T'
import './style.less'
import moment from 'moment'
import PropTypes from 'prop-types'

export const RecaptchaV2Challenge = injectIntl(props => {
  const { ip, intl, onFail } = props
  const url = window.location.href
  const dateString = moment().format('HH:mma, DD MMM YYYY')

  useEffect(() => {
    grecaptcha.render('recaptcha-container', {
      sitekey: props.siteKey,
      callback: props.onSuccess
    })
  }, [])

  useEffect(() => {
    function hideScrollbar () {
      document.body.style.overflow = 'hidden'
    }
    window.addEventListener('resize', hideScrollbar)
    hideScrollbar()

    let oldOnPopstate = null
    if (window.onpopstate) {
      oldOnPopstate = window.onpopstate
    }
    function onPopState (ev) {
      if (oldOnPopstate) {
        oldOnPopstate(ev)
      }
      onFail(ev)
    }
    window.onpopstate = onPopState
    return () => {
      window.removeEventListener('resize', hideScrollbar)
      document.body.style.overflow = 'auto'
      if (oldOnPopstate) {
        window.onpopstate = oldOnPopstate
      } else {
        window.onpopstate = () => {}
      }
    }
  }, [])

  const explanations = useMemo(function getExplanations () {
    const items = [
      intl.formatMessage({ id: 'recaptcha_challenge.explanation_1' }),
      intl.formatMessage({ id: 'recaptcha_challenge.explanation_2' }),
      intl.formatMessage({ id: 'recaptcha_challenge.explanation_3' })
    ]
    return items.map((item, i) => <li key={i}>{item}</li>)
  }, [])

  return (
    <div className='page'>
      <div className='header'>
        <div className='logo'>
          <img src={NvLogo} alt='Ninja van' />
        </div>
      </div>
      <div className='content'>
        <div className='inner'>
          <div className='title'>
            <T id='recaptcha_challenge.page_title' />
          </div>
          <div className='description'>
            <T
              id='recaptcha_challenge.page_description'
              values={{
                explanations: <p>{explanations}</p>
              }}
            />
          </div>
          <div className='rc-container' id='recaptcha-container' />
          <div className='footer'>
            <T id='recaptcha_challenge.page_footer' values={{ url, date: dateString, ip }} />
          </div>
        </div>
      </div>
    </div>
  )
})

RecaptchaV2Challenge.propTypes = {
  siteKey: PropTypes.string,
  onSuccess: PropTypes.func,
  onFail: PropTypes.func,
  ip: PropTypes.string,
  date: PropTypes.number, // timestamp
  intl: intlShape
}
